/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleDto } from './RoleDto';
import {
    RoleDtoFromJSON,
    RoleDtoFromJSONTyped,
    RoleDtoToJSON,
    RoleDtoToJSONTyped,
} from './RoleDto';

/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    userName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {Array<RoleDto>}
     * @memberof UserDto
     */
    roles: Array<RoleDto>;
    /**
     * 
     * @type {RoleDto}
     * @memberof UserDto
     */
    currentRole: RoleDto;
    /**
     * 
     * @type {Date}
     * @memberof UserDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserDto
     */
    lastLoginAt?: Date | null;
}

/**
 * Check if a given object implements the UserDto interface.
 */
export function instanceOfUserDto(value: object): value is UserDto {
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('currentRole' in value) || value['currentRole'] === undefined) return false;
    return true;
}

export function UserDtoFromJSON(json: any): UserDto {
    return UserDtoFromJSONTyped(json, false);
}

export function UserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'emailConfirmed': json['emailConfirmed'] == null ? undefined : json['emailConfirmed'],
        'roles': ((json['roles'] as Array<any>).map(RoleDtoFromJSON)),
        'currentRole': RoleDtoFromJSON(json['currentRole']),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'lastLoginAt': json['lastLoginAt'] == null ? undefined : (new Date(json['lastLoginAt'])),
    };
}

export function UserDtoToJSON(json: any): UserDto {
    return UserDtoToJSONTyped(json, false);
}

export function UserDtoToJSONTyped(value?: UserDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'userName': value['userName'],
        'emailConfirmed': value['emailConfirmed'],
        'roles': ((value['roles'] as Array<any>).map(RoleDtoToJSON)),
        'currentRole': RoleDtoToJSON(value['currentRole']),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'lastLoginAt': value['lastLoginAt'] == null ? value['lastLoginAt'] : value['lastLoginAt'].toISOString(),
    };
}

